export default function (i) {
  return i + suffix(i);
}

const suffixes = {
  1: 'st',
  2: 'nd',
  3: 'rd'
};

export function suffix(n) {
  if(parseInt(n) == n) {
    const isTeen = Math.floor(n / 10) % 10 === 1;
    return suffixes[!isTeen && n % 10] || 'th';
  }
}



// WEBPACK FOOTER //
// ./utils/OrdinalSuffix.js